import React from 'react';

export default function PrivacyPage() {
  return (
    <div>
      <h2>Privacy Policy</h2>
      <p>This app stores small amounts of data locally in your browser using cookies. Stored data includes saved teams and metadata about ongoing drafts so you can rejoin drafts and export teams.</p>
      <p>No personal data is transmitted to third parties by the app by default. If you choose to share data (for example, by pasting or sharing lobby codes), that information may be visible to others you share it with.</p>
      <p>To remove locally stored data, use the "Clear Saved Teams" or "Clear Ongoing Drafts" buttons in the lobby controls.</p>
      <p>We (the API Client) use several Google APIs, including YouTube API Services, to help improve chat experience.</p>
      <p>The API Client allows third parties to serve content, including advertisements.</p>
      <p>See <a href="https://policies.google.com/privacy?hl=en-US@gmail.com">Google's privacy policy.</a></p>
    </div>
  );
}
